import React, { useCallback } from 'react';
import styles from 'assets/css/SMARTGoal.module.css';
import LoadingHandler from 'Components/LoadingWrapper';
import { SMARTGoalContextProvider } from 'context/SMARTGoalAppContext';
import { queryProps } from 'Components/SMARTGoal/SMARTGoalHelper';
import SMARTGoalProgress from 'Components/SMARTGoal/SMARTGoalProgress';
import SMARTGoalEditor from 'Components/SMARTGoal/SMARTGoalEditor';
import SMARTGoalPageContent from 'Components/SMARTGoal/SMARTGoalPageContent';
import SMARTGoalNavigation from 'Components/SMARTGoal/SMARTGoalNavigation';

function SMARTGoalsApp(props) {
    const dashboardVariantID = props.dashboardVariantID;

    return (
        <div>
            <LoadingHandler retrievalUrl={queryProps.appSteps.retrievalUrl} componentName={queryProps.appSteps.componentName} queryOpts={{ select: useCallback((data) => (data.TotalGoals), []) }}>
                {(data) => (
                    <SMARTGoalContextProvider maxSteps={data}>
                        <SMARTGoalAppDisplay />
                    </SMARTGoalContextProvider>
                )}
            </LoadingHandler>
        </div>
    );
}

export default SMARTGoalsApp;

function SMARTGoalAppDisplay() {
    return (
        <div className={styles['sg-app__layout']}>
            <div className={styles['sg-app__progress-column']}>
                <SMARTGoalProgress   />
            </div>
            <div className={styles['sg-app__sg-step-column']}>
                <div>
                    <SMARTGoalPageContent />
                    <SMARTGoalEditor />
                    <SMARTGoalNavigation />
                </div>
            </div>
        </div>
    )
}